module.exports = __webpack_public_path__ + "img/luxury-2.70293845.png";